import React, { PropsWithChildren } from "react"
import { CSSTransition } from 'react-transition-group'
import { PropsWithTheme } from "../../library/Theme"

interface IconButtonProps {
  text?: string | null
  onPress: () => void
}

export default function IconButton({ theme, text, onPress, children }: PropsWithChildren<PropsWithTheme<IconButtonProps>>) {
  return (
    <CSSTransition in appear timeout={300} classNames="iconAnimate" unmountOnExit>
      <div className="iconButtonContainer">
        <div className="iconButton" style={theme.buttonStyle} onClick={onPress}>
          {children}
        </div>
        {text &&
          <>
            <br />
            <span className="text" style={theme.textStyle}>{text}</span>
          </>
        }
      </div>
    </CSSTransition>
  )
}